import { createReducer } from 'typesafe-actions';
import produce from 'immer';

import * as Actions from '../actions/accountAction';
import {
  initResponseAccountData,
  AccountData,
  AccountState
} from '../models/accountModel';

export const accountReducer = createReducer<
  AccountState,
  Actions.AccountAction
>(initResponseAccountData)
  // .handleAction(Actions.register.success, (state, action) =>
  //   produce(state, draft => {
  //     const res = action.payload;

  //   })
  // )

  .handleAction(Actions.agreeTerms, (state, action) =>
    produce(state, draft => {
      const res = action.payload;
      draft.agreeTerms = res;
      // draft.terms = res;
    })
  )
  .handleAction(Actions.termsList.success, (state, action) =>
    produce(state, draft => {
      const res = action.payload;
      draft.termsList = res;

      // draft.terms = res;
    })
  );
